import { useEffect } from "react";
import type { VideoItem } from "../types";
import { CloseIcon } from "./icons";

export function VideoModal({
	video,
	onClose,
}: {
	video: VideoItem | null;
	onClose: () => void;
}) {
	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		window.addEventListener("keydown", onKey);
		return () => window.removeEventListener("keydown", onKey);
	}, [onClose]);

	return (
		<div className={`video-modal-overlay${video ? " open" : ""}`} onClick={onClose}>
			<div className="video-modal" onClick={(e) => e.stopPropagation()}>
				<div className="video-modal__player">
					{video && <video src={video.src} poster={video.poster} controls autoPlay />}
				</div>
				<div className="video-modal__info">
					<div>
						<div className="video-modal__info-tag">{video?.tag}</div>
						<div className="video-modal__title">{video?.label}</div>
						{video?.desc && <div className="video-modal__desc">{video.desc}</div>}
					</div>
					<button className="video-modal__close" onClick={onClose} aria-label="Cerrar">
						<CloseIcon />
					</button>
				</div>
			</div>
		</div>
	);
}
